import { useFormContext } from 'react-hook-form'
import { EVariableType } from 'src/types/variable'
import { TNodeFormValues } from '../../node.type'
import { BooleanConditionList } from './boolean-condition/boolean-condition-list.component'
import { IntegerRangesConditionList } from './integer-range-condition/integer-ranges-condition-list.component'
import { NodeDashboardSection } from './node-dashboard-section.component'
import { NodeMediaRequiredToggle } from './node-media-required-toggle.component'

export function NodeConditionalSections() {
  const { watch } = useFormContext<TNodeFormValues>()
  const variable = watch('variable')

  if (!variable) {
    return null
  }

  if (variable.type === EVariableType.BOOLEAN) {
    return <BooleanConditionList />
  }

  if (variable.type === EVariableType.INTEGER_VALUE_RANGE) {
    return <IntegerRangesConditionList />
  }

  // MEDIA variables have output branches (mediaUploaded, plus mediaNotUploaded when the
  // document is optional) handled directly on the canvas node. The configurable options in
  // the form panel are:
  // - an optional human review request (dashboard-v2 feature flag)
  // - whether the upload is mandatory (NodeMediaRequiredToggle)
  if (variable.type === EVariableType.MEDIA) {
    return (
      <>
        <NodeDashboardSection />
        <NodeMediaRequiredToggle />
      </>
    )
  }

  return null
}
